import { render, staticRenderFns } from "./TransformScript.vue?vue&type=template&id=f60a1f94&scoped=true"
import script from "./TransformScript.vue?vue&type=script&lang=ts"
export * from "./TransformScript.vue?vue&type=script&lang=ts"
import style0 from "./TransformScript.vue?vue&type=style&index=0&id=f60a1f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60a1f94",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TransformScriptCodeHilight: require('/app/components/TransformScriptCodeHilight.vue').default})
